<template>
  <div style="padding: 20px">

    <div class="tip">
      <p>选择已设定的退货单分组，设置退货审核规则，实现不同退货单使用不同规则进行审核，不符合审核规则的退货单自动判断为异常，异常退货单将通过人工审核处理。</p>
    </div>

    <!--按钮-->
    <div>
      <el-button class="mybtn-blue2" style="width: 100px" @click="showAddDialog()">新增</el-button>
    </div>

    <!--标题-->
    <div class="config-title">退货审核规则</div>

    <!--表格-->
    <el-table :data="main$data" v-loading="main$loading" size="medium">
        <el-table-column type="index" label="序号" width="50" align="center" header-align="center"> </el-table-column>
        <el-table-column prop="name" label="规则名称" width="180" align="center" header-align="center"> </el-table-column>
        <el-table-column prop="groups" label="退单分组" width="220" align="center" header-align="center"> </el-table-column>
        <el-table-column prop="description" label="说明" width="260" align="center" header-align="center"> </el-table-column>
        <el-table-column prop="states" label="状态" width="100" align="center" header-align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.states == '0'">停用</span>
                <span v-else-if="scope.row.states == '1'" style="color: #29CF87">启用</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" header-align="center">
            <template slot-scope="scope">
                <el-button type="text" @click="table_update(scope.row)">修改</el-button>
                <el-button type="text" @click="table_delete(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--dialog 新增、编辑-->
    <el-dialog :title="editDialogType=='add'?'新增退单审核规则':'编辑退单审核规则'"
               :visible.sync="editDialogVisible"
               class="mydialog mydialog_add_order_group"
               :append-to-body="true">
      <el-form :label-position="'right'" label-width="90px" class="myform">
        <input type="hidden" v-model="editData.id">
        <!--/-->
        <el-form-item label="规则名称：">
            <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.name"></el-input>
        </el-form-item>
        <!--/-->
        <el-form-item label="退单分组：">
            <div>选择已设定退单分组</div>
            <el-checkbox-group v-model="editData.groupRule">
                <el-checkbox v-for="(item,item_idx) in data_returnGroup" :key="item_idx"
                             :label="item.id+''">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <!--/-->
        <el-form-item label="规则设置：">
          <el-select size="small" value="选择规则" v-model="editData.ReturnAuditType" @change="selectRule">
            <el-option v-for="(item,item_idx) in data_ReturnAuditType" :key="item_idx"
                       :label="item.value" :value="item.code"></el-option>
          </el-select>
          <!----------------规则 START---------------->
          <div v-for="(item,item_idx) in data_ReturnAuditType" :key="item_idx">
            <div v-if="item.code=='01'">
                <!--退货价格-->
                <div v-if="editData['r_show_'+item.code]">
                    <span class="subtitle">退货价格</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                    <div>
                        <el-checkbox label="按成交时价格退货" v-model="editData.rules['01']['01'].checked" @change="onlyCheckOne('01',['01','02'],'01')"></el-checkbox>
                        <el-checkbox label="按当前销售价格退货" v-model="editData.rules['01']['02'].checked" @change="onlyCheckOne('01',['01','02'],'02')"></el-checkbox>
                    </div>
                </div>
            </div>
            <div v-if="item.code=='02'">
                <!--退货数量-->
                <div v-if="editData['r_show_'+item.code]">
                    <span class="subtitle">退货数量</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                    <div class="dg-desc">限制单个商品退货数量</div>
                    <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['02']['03'].val"></el-input>
                    <div class="dg-desc">限制退货商品类别数量</div>
                    <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['02']['04'].val"></el-input>
                </div>
            </div>
            <div v-if="item.code=='03'">
                <!--商品-->
                <div v-if="editData['r_show_'+item.code]">
                    <span class="subtitle">商品</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                    <div>
                      <el-button type="primary" size="small" @click="selectGoods_show" style="margin-bottom: 10px">添加商品</el-button>
                      <el-table :data="editData.rules['03']['05'].goodsList" size="small" border style="margin-bottom: 10px">
                        <el-table-column align="center" header-align="center" width="60">
                          <template slot-scope="scope">
                            <el-checkbox-group>
                              <el-button size="mini" type="danger" icon="el-icon-delete" @click="rules_selGoods_del(scope.row)"></el-button>
                            </el-checkbox-group>
                          </template>
                        </el-table-column>
                        <el-table-column prop="barcode" label="编码货号" align="center" header-align="center"></el-table-column>
                        <el-table-column prop="goodsName" label="商品" align="center" header-align="center"></el-table-column>
                        <el-table-column  prop="skuVname" label="规格" align="center" header-align="center"></el-table-column>
                        <el-table-column prop="unitName" label="单位" align="center" header-align="center"></el-table-column>
                      </el-table>
                    </div>
                </div>
            </div>
            <div v-if="item.code=='04'">
                <!--客户-->
                <div v-if="editData['r_show_'+item.code]">
                    <span class="subtitle">客户</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                    <div>
                      <el-autocomplete
                          size="small"
                          v-model="editData.rules['04']['06'].customerVal"
                          placeholder="请输入"
                          :fetch-suggestions="queryCustomer"
                          @select="handleCustomerSelect">
                          <template slot="append"><i class="el-icon-search"></i></template>
                      </el-autocomplete>
                      <div>
                        <el-tag style="margin-right: 5px"
                                v-for="item in editData.rules['04']['06'].customerList"
                                :key="item.customerId" closable @close="handleCustomerClose(item)"
                                :type="item.customerId">
                            {{item.customerName}}
                        </el-tag>
                      </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <!--其他-->
            </div>
          </div>
          <!----------------规则 END---------------->
        </el-form-item>
        <!--/-->
        <el-form-item label="权重：">
          <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.weight"></el-input>
          <div class="dg-desc">填写数字越大，代表权重越高，优先级越高</div>
        </el-form-item>
        <!--/-->
        <el-form-item label="描述：">
            <el-input size="small" type="textarea" placeholder="请填写对退货的简要描述" v-model="editData.description"></el-input>
        </el-form-item>
        <!---->
        <el-form-item label="状态：">
          <el-radio-group v-model="editData.states">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="mybtn-blue2" @click="saveDialogData">保存</el-button>
        <el-button @click="editDialogVisible=false">取消</el-button>
      </div>
    </el-dialog>

    <!--选择商品对话框-->
    <el-dialog title="选择商品"
               :visible.sync="selGoodsDialogVisible"
               class="mydialog" width="800px"
               :append-to-body="true">
        <div style="margin-bottom: -15px">
            <!--查询条件-->
            <el-form :inline="true" class="myform">
                <el-form-item label="来源">
                    <el-select placeholder="请选择" v-model="selGoods$query_dataSource">
                        <el-option v-for="(item,idx) in data_dataSource" :key="idx" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关键字">
                    <el-input placeholder="商品名称/条码" v-model="selGoods$query_condition"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="fetchData_goods">搜索</el-button>
                </el-form-item>
            </el-form>
            <!--table、分页-->
            <el-table :data="selGoods$data" v-loading="selGoods$loading" size="medium"
                      style="min-height: 0;margin: 10px 0px" height="270"
                      @selection-change="handleSelectionChange_goods">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="goodsName" label="商品" width="220" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="barcode" label="条码货号" width="180" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="skuVname" label="规格" width="160" align="center" header-align="center"> </el-table-column>
                <el-table-column prop="unitName" label="单位" align="center" header-align="center"> </el-table-column>
            </el-table>
            <el-pagination style="float: right;margin: 14px"
                       layout="prev, pager, next"
                       :page-size="selGoods$page_size"
                       :current-page="selGoods$curr_page"
                       :total="selGoods$total"
                        @current-change="handlePageChange_goods"></el-pagination>
            <div style="clear: both"></div>
        </div>
        <div slot="footer">
            <el-button class="mybtn-blue2" style="width: 100px" @click="selectGoods_ok">确定</el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 表格
            main$loading: false,
            main$data: [],
            // 下拉框等数据
            data_ReturnAuditType:[],
            data_returnGroup:[], // 退单分组规则
            data_dataSource: [],
            // 新增、编辑对话框
            editDialogVisible:false,
            editDialogType:'',
            editData:{ },
            // 选择商品
            selGoodsDialogVisible: false,
            selGoods$query_dataSource: '',
            selGoods$query_condition: '',
            selGoods$page_size: 5,
            selGoods$curr_page: 1,
            selGoods$loading: false,
            selGoods$total: 0,
            selGoods$data: [],
            selGoods$selection: [],
        }
    },
    methods:{
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/rule/orderreturnaudit/getList'), {

            }).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$data = [];
                }
                else {
                    self.main$data = res.data.data;
                }
            });
        },
        table_update: function (row) {
            let self = this;

            self.xEui.myloading('加载中...')
            self.xFetch.post(self.xApi('/robot/rule/orderreturnaudit/getDetails'), {
                id:row.id
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                let obj = res.data.data;
                let editData = self.getDefaultEditData();

                editData.id = obj.id;
                editData.name = obj.name;
                editData.groupRule = (obj.groupRule||'').split(',');
                editData.weight = obj.weight;
                editData.description = obj.description;
                editData.states = obj.states + '';

                obj.typeList.forEach(function(item){
                    let code = item.type;

                    // 显示
                    editData['r_show_'+code]=true;

                    // 值
                    item.contentList.forEach(function(chItem){
                        try{
                            let define = editData.rules[code][chItem.content];
                            if (define.hasOwnProperty('checked')) {
                                define.checked = chItem.value == 1 ? true : false;
                            }
                            else if(define.hasOwnProperty('val')){
                                define.val = chItem.value;
                            }
                            else if(define.hasOwnProperty('goodsList') && chItem.value){
                                // 商品 - START
                                self.xFetch.post(self.xApi('/robot/goods/getSimpleGoods'), {
                                    page: 1,
                                    rows: 200,
                                    dataSource: '',
                                    condition: '',
                                    'skuIds[]':chItem.value
                                }, {xPostType: 'form'}).then(function (res) {
                                    define.goodsList = res.data.rows
                                });
                                // 商品 - END
                            }
                            else if(define.hasOwnProperty('customerList') && chItem.value){
                                // 客户 - START
                                self.xFetch.post(self.xApi('/robot/customer/queryCustomer'), {
                                    'cusIds[]':chItem.value
                                }, {xPostType: 'form'}).then(function (res) {
                                    res.data.data.forEach(function(item){item.value=item.customerName});
                                    define.customerList = res.data.data
                                });
                                // 客户 - END
                            }
                        }
                        catch(err) {

                        }
                    });
                });

                // show dialog
                self.editDialogVisible = true;
                self.editDialogType = 'update';
                self.editData = editData;
            });
        },
        table_delete: function (row) {
            let self = this;
            self.xEui.confirm('','确认要删除该条记录吗？',function(){
                self.xEui.myloading('删除中...')
                self.xFetch.post(self.xApi('/robot/rule/orderreturnaudit/delete'), {
                    id:row.id
                },{xPostType:'form'}).then(function (res) {
                    self.xEui.loading_close();

                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    else{
                        self.xEui.msg_success('删除成功')
                        self.fetchData();
                    }
                });
            })
        },
        getDefaultEditData: function(){
            let self = this;
            let editData = {
                groupRule:[], // 退单分组
                states:'1',   // 状态
                rules:{        // 审核规则
                    '01':{     // 退货价格
                        '01':{ checked:false},         // 按成交时价格退货
                        '02':{ checked:false},         // 按当前销售价格退货
                    },
                    '02':{     // 退货数量
                        '03':{ val:''}, // 限制单个商品退货数量
                        '04':{ val:''}, // 限制退货商品类别数量
                    },
                    '03':{     // 商品
                        '05':{
                            goodsList:[]  // 和 selGoods$data 结构一致
                        },
                    },
                    '04':{     // 客户
                        '06':{
                            customerVal:'',
                            customerList:[] // {customerId:'',customerName:''}
                        },
                    }
                }
            };
            return editData;
        },
        // 指定的选项列表中仅能选中一个
        onlyCheckOne: function(ruleCode,codeArr,code){
            let self = this;
            for(let p in self.editData.rules[ruleCode]){
                if(p == code){

                }
                else{
                    self.editData.rules[ruleCode][p].checked = false
                }
            }
        },
        showAddDialog: function(){
            this.editDialogVisible = true;
            this.editDialogType = 'add';
            this.editData = this.getDefaultEditData();
        },
        selectRule: function(){
            let code = this.editData.ReturnAuditType;
            if(code){
                this.$set(this.editData, 'r_show_' + code, true)
            }
        },
        removeRule: function(code){
            this.$set(this.editData, 'r_show_' + code, false)
        },
        // 选择商品 - START
        selectGoods_show: function(){
            this.selGoodsDialogVisible = true;
            this.fetchData_goods();
        },
        selectGoods_ok: function(){
            let self = this;

            if(!self.selGoods$selection.length){
                self.xEui.msg_error('请选择商品')
                return;
            }

            // 隐藏对话框
            self.selGoodsDialogVisible = false

            // 选中值
            let selData = [];
            self.selGoods$selection.forEach(function(item){
                self.editData.rules['03']['05'].goodsList.push(item)
            });
        },
        fetchData_goods: function(){
            let self = this;

            self.selGoods$loading = true

            self.xFetch.post(self.xApi('/robot/goods/getSimpleGoods'), {
                page: self.selGoods$curr_page,
                rows: self.selGoods$page_size,
                dataSource: self.selGoods$query_dataSource,
                condition: self.selGoods$query_condition,
            },{xPostType:'form'}).then(function (res) {
                self.selGoods$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.selGoods$total = 0;
                    self.selGoods$data = [];
                }
                else {
                    self.selGoods$total = res.data.total;
                    self.selGoods$data = res.data.rows;
                }
            });
        },
        handlePageChange_goods: function(val){
            this.selGoods$curr_page = val;
            this.fetchData_goods();
        },
        handleSelectionChange_goods: function (val) {
            this.selGoods$selection = val
        },
        rules_selGoods_del: function(row){
            let self = this
            let newData = [];
            self.editData.rules['03']['05'].goodsList.forEach(function(item){
                if(item.skuId != row.skuId){
                    newData.push(item)
                }
            })
            self.editData.rules['03']['05'].goodsList = newData;
        },
        // 选择商品 - END
        // 选择客户 - START
        queryCustomer: function(queryString, cb){
            let self = this;
            self.xFetch.post(self.xApi('/robot/customer/queryCustomer'), {
                condition:queryString,
            },{xPostType:'form'}).then(function (res) {
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                // [{customerId:'1',customerName:'川3科技A',value:'川3科技A'}]
                res.data.data.forEach(function(item){
                    item.value = item.customerName;
                });
                cb(res.data.data);
            });
        },
        handleCustomerSelect: function (obj) {
            let self = this;
            self.editData.rules['04']['06'].customerVal = '';

            let isAdd = false;
            self.editData.rules['04']['06'].customerList.forEach(function (item) {
                if (item.customerId == obj.customerId) {
                    isAdd = true;
                }
            });
            if (!isAdd) {
                self.editData.rules['04']['06'].customerList.push(obj);
            }
        },
        handleCustomerClose: function(obj){
            let self = this
            let newData = [];
            self.editData.rules['04']['06'].customerList.forEach(function(item){
                if(item.customerId != obj.customerId){
                    newData.push(item)
                }
            })
            self.editData.rules['04']['06'].customerList = newData;
        },
        // 选择客户 - END
        saveDialogData: function(){
            let self = this;
            let postData = {
                'id':self.editData.id,
                'name':self.editData.name,
                'groupRule':self.editData.groupRule.join(','),
                'weight':self.editData.weight,
                'description':self.editData.description,
                'states':self.editData.states,
                'typeList':[]
            }

            for (let p in self.editData) {
                if (p.indexOf('r_show_') >= 0 && self.editData[p]) {
                    let code = p.replace('r_show_', '');

                    let contentList = [];
                    for(let con_code in self.editData.rules[code]){
                        let con = self.editData.rules[code][con_code];
                        if(con.hasOwnProperty('checked')){
                            contentList.push({
                                'content': con_code,
                                'value': con.checked?'1':'0'
                            });
                        }
                        else if(con.hasOwnProperty('val')){
                            contentList.push({
                                'content': con_code,
                                'value': con.val,
                            });
                        }
                        else if(con.hasOwnProperty('goodsList')){
                            let skuIds = [];
                            con.goodsList.forEach(function(item){
                                skuIds.push(item.skuId);
                            });
                            contentList.push({
                                'content': con_code,
                                'value': skuIds.join(','),
                            });
                        }
                        else if(con.hasOwnProperty('customerList')){
                            let cusIds = [];
                            con.customerList.forEach(function(item){
                                cusIds.push(item.customerId);
                            });
                            contentList.push({
                                'content': con_code,
                                'value': cusIds.join(','),
                            });
                        }
                    }

                    postData.typeList.push({
                        "type": code,
                        "contentList": contentList
                    });
                }
            }

            if(!postData.name){
                self.xEui.msg_error('请输入名称')
                return;
            }

            if(!postData.groupRule){
                self.xEui.msg_error('请选择退单分组')
                return;
            }

            // save
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi(
                    postData.id ? '/robot/rule/orderreturnaudit/update' : '/robot/rule/orderreturnaudit/add'
            ), postData).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                else {
                    self.xEui.msg_success('保存成功')
                    self.editDialogVisible = false;
                    self.fetchData();
                }
            });
        }
    },
    created: function(){
        let self = this;

        // 表格数据
        self.fetchData();

        // 下拉框等数据
        //--退单审核规则类型
        self.xFetch.post(self.xApi('/robot/common/getOrderReturnAuditType'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }

            self.data_ReturnAuditType = res.data.data;
        });
        //--退单分组规则
        self.xFetch.post(self.xApi('/robot/rule/orderreturngroup/getList'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            let list = [];
            res.data.data.forEach(function (item) {
                if (item.app == '1'/*审核*/ || item.app == '3'/*全部*/) {
                    list.push(item)
                }
            });
            self.data_returnGroup = list;
        });
        //--数据来源
        self.xFetch.post(self.xApi('/robot/common/getDataSource'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_dataSource = res.data.data;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-input, .el-select, .el-date-editor.el-input{
    width: 220px;
  }
  .el-textarea{
    width: 370px;
  }
  /*config-title*/
  .config-title{ font-size: 13px;color: #333;font-weight: 700;padding: 30px 0; }
  /*mydialog_add_order_group*/
  .mydialog_add_order_group{ }
  .mydialog_add_order_group .dg-input{ width: 220px }
  .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399;line-height: 30px }
  p{
    margin: 0;
  }
  .subtitle{
    font-size: 16px;
    font-weight: bold;
    margin-right: 20px;
  }
</style>
<style>
  /*mydialog_add_order_group*/
  .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>


// WEBPACK FOOTER //
// src/views/config/strategy/return-audit-rule.vue